export default {
  namespaced: true,
  state: {
    offset: 0,
    limit: 30,
    count: 0,
    items: [],
    isAction: false
  },
  actions: {},
  mutations: {
    INCREASE_OFFSET(state: any) {
      state.offset += state.limit;
    },
    SET_COUNT(state: any, count: number) {
      state.count = count;
    },
    ADD_ITEMS(state: any, _items: Array<any>) {
      _items.forEach(el => state.items.push(el));
    },
    CHANGE_IS_ACTION(state: any) {
      state.isAction = !state.isAction;
    },
    CLEAR_SHOW_MORE(state: any) {
      state.offset = 0;
      state.count = 0;
      state.items = [];
      state.isAction = false;
    }
  },
  getters: {
    OFFSET(state: any) {
      return state.offset;
    },
    LIMIT(state: any) {
      return state.limit;
    },
    ITEMS(state: any) {
      return state.items;
    },
    IS_SHOW(state: any) {
      return state.count > state.items.length;
    },
    IS_ACTION(state: any) {
      return state.isAction;
    }
  }
};
